import { DEV_MODE } from '@cob/ui-genesis/helpers/cob.devmode.js';
import IndexedInstanceM from '../model/recordm.model.entity.indexedinstance.js';
import UnifiedSearchResultV from '../view/recordm.view.searchresult.unified.js';
import UriBuilder from '../helpers/module.uribuilder.js';

import ui from '@cob/ui-genesis/cob.ui.js';
import utils from '@cob/ui-genesis/cob.utils.js';

// The "Presenter" responsible for showing the unified search results
//
// $container: the jquery HTML wrapper for the enclosing element
//
var UnifiedSearchResultP = function(core, baseUri, domainM, searchM, instanceActions, $container) {

    var _indexedInstancesM = {},
        _onEntryPage = true;

    var confs = {rowsPerPage: searchM.getRowsPerPage()},
        hasViewDetaislPerm = core.hasPermission("module:view:instance.detail");

    var _resultV = new UnifiedSearchResultV(core, $container, confs, {
        moreRecordsClick: function() {
            searchM.loadMoreData();
        },
        executeInstanceAction: function(actionKey, instanceKey, instanceId) {
            var key = instanceKey + ":" + instanceId,
                indexedInstanceM = _indexedInstancesM[key];

            if (indexedInstanceM) {
                instanceActions.executeInstanceAction(actionKey, indexedInstanceM);
            }
        }
    });

    var _onSearchResult = function() {

        var searchResults = searchM.getSearchResults();

        var _newIndexedInstancesM = {},
        // a Latch that will fire after all the indexed instances are available
            modelLoadLatch = new utils.CountdownLatch(searchResults.length, function() {
                // Release previous laaded instances
                _releaseIndexedInstancesM(_indexedInstancesM);

                // Update our indexedInstancesM
                _indexedInstancesM = _newIndexedInstancesM;

                // Update the UI
                _updateViewData();

            }, "model loaded");

        _onEntryPage = false;

        // we trigger loading the models for all the IDs that we received,
        // and subscribe to the updates/deletes
        searchResults.forEach(function(result) {
            IndexedInstanceM.get(core, result.id, {
                success: function(indexedInstanceM) {
                    var indexedInstanceId = indexedInstanceM.data.id,
                        key = indexedInstanceM.getEntityKey() + ":" + indexedInstanceId;

                    // if not already loaded then subscrive for updates and deletes
                    if (!_indexedInstancesM[key]) {
                        core.subscribe(indexedInstanceM.update_event_name, _updateViewData);
                        core.subscribe(indexedInstanceM.delete_event_name, _onInstanceDeleted);
                    }

                    indexedInstanceM.uri = hasViewDetaislPerm
                        ? "#/" + UriBuilder.buildUriForInstance(indexedInstanceM.data.id)
                        : undefined;

                    _newIndexedInstancesM[key] = indexedInstanceM;

                    modelLoadLatch.countDown("model:loaded:" + key);
                }
            });
        });

        core.publish('unified-search:results-ready');

    };

    var _buildSearchByDefinitionUris = function(searchQuery, definitions) {
        definitions.forEach(function(definition) {
            definition.uri = "#/" + UriBuilder.buildUriForSimpleSearchDefinition(
                definition.id,
                searchQuery
            );
        });
        return definitions;
    };

    var _updateViewData = function() {
        var _indexedInstancesData = [],
            currentQuery = searchM.getCurrentQuery() || "",
            perDefinitionTotal = _buildSearchByDefinitionUris(currentQuery, searchM.getDefinitions());


        utils.forEachOwn(_indexedInstancesM, function(key) {
            var indexedInstanceM = _indexedInstancesM[key];

            //inject canDuplicateInstance check
            indexedInstanceM.canDuplicateInstance = function(){
                //don't want to duplicate from here; its very inefficient since we have to search the definition
                // for each record...
                //anyway, we need to define the function to avoid an error
                return false;
            };

            _indexedInstancesData.push({
                indexedInstanceM: indexedInstanceM,
                actions: instanceActions.getInstanceActions(indexedInstanceM),
                title: indexedInstanceM.getInstanceLabel(true, core.getLocale()),
                details: indexedInstanceM.getInstanceDescription(core.getLocale())
            });
        });

        _resultV.clearData();
        _resultV.updateSideNav(searchM.getTotalMatchingResults(), perDefinitionTotal);
        _resultV.showData(_indexedInstancesData);

        DEV_MODE && window.console.log("Showing the results of the search");
        _resultV.showContainer();
    };

    var _onSearchCountResult = function() {
        var total,
            currentQuery,
            perDefinitionTotal;

        if(_onEntryPage){
            total = searchM.getTotalMatchingResults();
            currentQuery = searchM.getCurrentQuery() || "";
            perDefinitionTotal = _buildSearchByDefinitionUris(currentQuery, searchM.getDefinitions());

            _resultV.setTotalRecords(domainM, total);
            _resultV.updateBottomNav(total, perDefinitionTotal);
        }
    };

    var _onInstanceDeleted = function(e, data) {
        var key = (data.entityKey + ":" + data.id),
            deletedInstanceM = _indexedInstancesM[key];

        searchM.removeFromSearchResult(deletedInstanceM);

        core.unsubscribe(deletedInstanceM.delete_event_name, _onInstanceDeleted);
        core.unsubscribe(deletedInstanceM.update_event_name, _updateViewData);

        delete _indexedInstancesM[key];

        deletedInstanceM.release();

        _updateViewData();
    };

    var _releaseIndexedInstancesM = function(indexedInstancesM) {
        utils.forEachOwn(indexedInstancesM, function(key) {
            indexedInstancesM[key].release();
        });
    };

    var _showSearchError = function(e, data) {
        var errorMsg = core.translateString("recordm.error.codes", "generic." + data.errorCode.toString())
            || core.translateString("recordm.error.codes", "search.error");

        ui.notification.showError(errorMsg);
    };

    var _subscribeEvents = function() {
        core.subscribe("recordm:search:finished", _onSearchResult);
        core.subscribe('recordm:search:error', _showSearchError);
        core.subscribe("recordm:search:finished:count", _onSearchCountResult);
        core.subscribe("recordm:search:error:count", _showSearchError);
    };

    var _unsubscribeEvents = function() {
        core.unsubscribe("recordm:search:finished", _onSearchResult);
        core.unsubscribe('recordm:search:error', _showSearchError);
        core.unsubscribe("recordm:search:finished:count", _onSearchCountResult);
        core.unsubscribe("recordm:search:error:count", _showSearchError);
    };

    var _init = function() {
        _resultV.init();

        if (domainM.hasDefinitions()) {
            _subscribeEvents();

            if (searchM.getCurrentQuery() !== undefined) {
                _onEntryPage = false;

                _resultV.showSearchInProgressMode();

            } else {
                searchM.doSearch(undefined, 0, undefined, false, ":count", 0);

                _resultV.showContainer();
            }

        } else {
            ui.notification.showWarning(
                core.translateString("recordm.error.codes", "search.domain-without-defs"),
                true
            );
        }
    };

    var _pause = function() {
        _unsubscribeEvents();
    };

    var _resume = function() {

        _subscribeEvents();

        if (searchM.getCurrentQuery() !== undefined) {
            _onEntryPage = false;

            _updateViewData();

        }else {
            _onEntryPage = true;

            _resultV.showInStartMode();
            searchM.doSearch(undefined, 0, undefined, false, ":count", 0);
        }
    };

    var _destroy = function() {
        _unsubscribeEvents();

        _releaseIndexedInstancesM(_indexedInstancesM);
        _indexedInstancesM = {};

        _resultV.showInStartMode();
    };

    return {
        init: _init,
        pause: _pause,
        resume: _resume,
        destroy: _destroy
    };
};

export default UnifiedSearchResultP;
